function phoneDigitsFromPhone(phone: string | null): string {
	if (phone === null || phone === undefined) {
		return '';
	}

	return String(phone).replace(/\D/g, '');
}

function readUsername(value: string | null | undefined): string {
	if (value === null || value === undefined) {
		return '';
	}

	return String(value).trim();
}

function hasGreeting(greeting: string | null | undefined): boolean {
	if (greeting === null || greeting === undefined) {
		return false;
	}

	return String(greeting).trim() !== '';
}

function buildMaxMessengerHref(
	username: string,
	phoneDigits: string,
	greeting?: string | null,
): string {
	if (username !== '') {
		if (username.indexOf('http://') === 0 || username.indexOf('https://') === 0) {
			return username;
		}

		if (username.indexOf('max.ru/') !== -1) {
			return 'https://' + username.replace(/^https?:\/\//, '');
		}

		const slug = username.replace(/^@/, '').replace(/^u\//, '');

		return 'https://max.ru/u/' + slug;
	}

	if (phoneDigits !== '') {
		if (hasGreeting(greeting)) {
			return 'https://max.ru/:share?text=' + encodeURIComponent(String(greeting));
		}

		return 'https://max.ru/';
	}

	return '';
}

export function buildMessengerHref(
	type: string,
	username: string | null,
	phone: string | null,
	greeting?: string | null,
): string {
	const code = String(type).toUpperCase();
	const usernameText = readUsername(username);
	const phoneDigits = phoneDigitsFromPhone(phone);

	if (code === 'WHATSAPP') {
		if (phoneDigits === '') {
			return '';
		}

		let href = 'https://wa.me/' + phoneDigits;

		if (hasGreeting(greeting)) {
			href += '?text=' + encodeURIComponent(String(greeting));
		}

		return href;
	}

	if (code === 'TELEGRAM') {
		if (usernameText === '') {
			return '';
		}

		return 'https://t.me/' + usernameText.replace(/^@/, '');
	}

	if (code === 'VIBER') {
		if (phoneDigits === '') {
			return '';
		}

		return 'viber://chat?number=' + phoneDigits;
	}

	if (code === 'MAX') {
		return buildMaxMessengerHref(usernameText, phoneDigits, greeting);
	}

	return '';
}

export function buildMailtoHref(email: string): string {
	const text = String(email).trim();

	if (text === '') {
		return '';
	}

	return 'mailto:' + text;
}
